import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/arnold.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
		Shelfmark LBr 160 Bl. 97-8<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
		Date: 5 June 1716<br /><br />
        Translated from the French<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (64k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Leibniz to John Arnold (5 June 1716)</title>
            <meta name="description" content="An English translation of a letter from GOTTFRIED WILHELM LEIBNIZ TO JOHN ARNOLD, from 5 June 1716" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ TO JOHN ARNOLD</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>LBr 160 Bl. 97v</b>]<br /><br />		

                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;My dispute with Mr Clarke continues.<a name="1" href="#note1"><sup>1</sup></a> You have indicated, Sir, that he mentioned something about it in print. I would like to have more information about this. Mr Clarke has attacked my expression, that God is <var>intelligentia supra mundana</var>,<a name="2" href="#note2"><sup>2</sup></a> claiming that I exclude him from the government of the world,<a name="3" href="#note3"><sup>3</sup></a> which is a manifest cavil. In my turn, I find fault with Mr Newton's <var>sensorium</var> of God; I also disapprove of the fact that these gentlemen make the world into a machine which [<b>LBr. 160 Bl. 98r</b>] goes wrong and stops by itself, like a badly-made watch, and that God needs to set it right from time to time by extraordinary interventions. I show also that by the supposition of a real space in bodies they establish an infinity of beings coeternal with God, and about which God can do nothing, and that these beings go against this great maxim, that nothing happens without there being a sufficient reason for it. Finally, I show that their philosophy is full of miracles, that is, of actions impossible to explain by the natures and forces of creatures, and that it seems from their response that their idea of 'miracle' is a poor one, and will win the disapproval of theologians, as if the difference between the miraculous and the natural holds only in our opinion and not in truth, and in relation to God. And that miracles were only God's less-common actions, whereas miracles (at least the principal ones) are those which surpass the forces of [<b>LBr. 160 Bl. 98v</b>] creatures, as would be creation and annihilation for example. This, then, is a summary of our dispute.<a name="4" href="#note4"><sup>4</sup></a> It seems to me that according to these gentlemen, God becomes imperfect, and is too much like the world-soul of ancient philosophers, because [according to them] he needs a sensorium, because he dwells in a machine as imperfect as our body, and because he keeps his machine going through the force that he impresses in it from time to time, just as the common man imagines the soul does in the body. In a word, the philosophy of these gentlemen seems to me a little degenerate, and unworthy of the greatness and wisdom of the author of things. I am sincerely,<br /><br />

                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Sir,<br /><br />
                Hanover, this 5 of June 1716.<span style={{float: 'right'}}>Your very humble and</span><br />
                To Mr Arnold, Doctor of Medicine in Exon<span style={{float: 'right'}}>very obedient servant,</span><br /><br />
                <span style={{float: 'right'}}>Leibniz</span>
                        <br /><br /><br />
                        <hr className='rightcol-hr' />
                        <br /><br />NOTES:<br /><br />
                        <a name="note1" href="#1">1.</a> Leibniz is referring here to his increasingly bitter exchange of letters with Samuel Clarke (1675-1729), the English divine and supporter of Isaac Newton.<br />
                        <a name="note2" href="#2">2.</a> 'a super-mundane intelligence'.<br />
                        <a name="note3" href="#3">3.</a> Clarke levelled this charge in his fifth letter to Leibniz. See <var>Philosophical Papers and Letters</var>, ed. Leroy E. Loemker, p. 695.<br />
                <a name="note4" href="#4">4.</a> What Leibniz has given is in fact a summary of his fourth letter to Clarke. For an English translation of that letter, see <var>Philosophical Papers and Letters</var>, pp. 687-91.
                <br /><br /><br />
                        &#169; Lloyd Strickland 2015
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
